import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import httpApiCall from "../../../service/api.service";
import { clearPartnerStorage, getStorageValue } from "../../../service/shared.service";
import toastr from "../../elements/toast";

const Logout = (props: any) => {
  const toastrService = new toastr(true);
  const [sppiner, setSppiner] = useState(false);
  const handleLogOut = async () => {
    let getProfile: any = getStorageValue("partnerProfile");
    if (getProfile && getProfile.length) {
      getProfile = getProfile[0];
    }
    const body = {
      access_token: getProfile.access_token
    }
    setSppiner(true);
    const logoutResp = await httpApiCall({ api: "partner_logout", type: "post", body });
    setSppiner(false);
    if (logoutResp && !logoutResp.is_error) {
      clearPartnerStorage();
      localStorage.removeItem('gridView');
      localStorage.removeItem('businessGridView');
      sessionStorage.removeItem("Tabs");
      sessionStorage.removeItem("activeTab");
    } else {
      toastrService.showError(logoutResp.original_text || logoutResp.err);
    }
  };
  return (
    <div >
      <Modal show={props.show} onHide={props.onHide} animation={false} centered className="logout">
        <Modal.Header className="justify-content-center">
        <h4>Logout Confirmation</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p className="mb-0">Do you want to Logout ?</p>
          </div>
        </Modal.Body>
        <Modal.Footer className=" d-flex justify-content-center mb-2">
          <Button variant="primary" onClick={props.onHide}>
            Cancel
          </Button>
          <Button disabled={sppiner} variant="secondary" onClick={handleLogOut}>
            Confirm
            {sppiner && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="ms-2"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Logout;
